import React, { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import { getFilteredTasks2 } from '../../service/Task';
import AppContext from '../../context/AppContext';
import { fetchFieldAgent } from '../../service/Configuration';
import { getTaskListAPI } from "../../service/mapView";

const BottomFilter = ({ setMarkers , setIsLoading}) => {
    const [activityModal, setActivityModal] = useState()
    const [selectData, setSelectData] = useState({
        visitStatuses: [],
        taskPriority: [],
        taskStatus: [],
        assignmentTypes: [],
        fieldAgents: [],
        accountNo: ""
    })
    const [fieldAgents, setFieldAgents] = useState([])
    const [accountsNo, setAccountNo] = useState([]);
    const [searchAccount, setSearchAccount] = useState(''); 
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const filterRef = useRef(null)
    const context = useContext(AppContext);
    const {
        selectedOrgId,
        activityId,
    } = context;

    // field Agents
    const fieldAgentOptions = (fieldAgents || [])?.map(agent => agent.userId);

    // visit Statue
    const visitStatusesOptions = ['Unvisited', 'Completed', 'Unsuccessful'];

    // Priority
    const priorityStatusesOptions = ['Low_Priority', 'Medium_Priority', 'High_Priority'];

    // task Status
    const taskStatusesOptions = ['Active', 'Assigned', 'In_Progress', 'Completed'];

    // assignment Types
    const assignmentOptions = ['Assigned', 'Unassigned'];

    // account no
    const accountOptions = accountsNo?.map((item) => item?.accountNo);

    // selected filter
    const isAllSelected = (field, options) => {
        return options.length > 0 && selectData[field]?.length === options.length;
    };

    // all filter selected
    const handleSelectAll = (field, options, checked) => {
        setSelectData((prev) => ({
            ...prev,
            [field]: checked ? [...options] : []
        }));
    };

    // common filter selector fun for manual select
    const handleFilterToggle = (field, priorityValue) => {
        setSelectData((prev) => {
            if (field === "accountNo") {
                return {
                    ...prev,
                    [field]: prev["accountNo"] === priorityValue ? "" : priorityValue,
                };
            }
            const alreadySelected = prev?.[field].includes(priorityValue);
            return {
                ...prev,
                [field]: alreadySelected
                    ? prev?.[field].filter((item) => item !== priorityValue)
                    : [...prev?.[field], priorityValue],
            };
        });
    };

    // const isChecked = (field, priorityValue) => selectData?.[field]?.includes(priorityValue);
    const isChecked = (field, value) => {
        const fieldValue = selectData?.[field];
        return Array.isArray(fieldValue)
            ? fieldValue.includes(value)
            : fieldValue === value;
    };


    // search account no
    const handleSearchAccount = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchAccount(query);
        const filteredAccount = accountsNo.filter(account =>
            account.accountNo.toLowerCase().includes(query)
        );
        setFilteredAccounts(filteredAccount);
    };


    useEffect(() => {
        const getBottomFilterData = async () => {
            try {
                setIsLoading(true)
                const data = await getFilteredTasks2(
                    activityId,
                    selectData,
                    selectedOrgId)

                setMarkers(data.body.value?.taskList || [])
            } catch (error) {
                setIsLoading(false)
                console.error("Error : ", error)
            }
            setIsLoading(false)
        }
        // if (selectData?.['taskPriority'].length > 0 || selectData?.['taskStatus'].length > 0 || selectData?.['visitStatuses'].length > 0 || selectData?.['assignmentTypes'].length > 0 || selectData?.['fieldAgents'].length > 0 || selectData?.['accountNo']) {
            getBottomFilterData()
        // }
    }, [selectData])

    useEffect(() => {

        const fetchActivity = async () => {
            try {
                const data = await fetchFieldAgent(activityId)
                setFieldAgents(data)
            } catch (error) {
                console.error("Error", error)
            }
        }

        const handleChangeStatus = async () => {
            try {
                const data = await getTaskListAPI(
                    activityId
                );

                if (data?.body?.value?.taskList) {
                    setMarkers(data.body.value.taskList);
                    setAccountNo(data?.body?.value?.taskList);
                    setFilteredAccounts(data?.body?.value?.taskList);
                } else {
                    setMarkers([]);
                    setAccountNo([])
                    setFilteredAccounts([])
                    console.log("No tasks received");
                }

            } catch (error) {
                console.error("Map Filter Status Error :", error)
            }
        }

        fetchActivity()
        handleChangeStatus()
    }, [activityId])

    // filters modal will be close on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setActivityModal('');
            }
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setActivityModal('');
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='bg-black bg-opacity-80 mb-2 absolute bottom-0 w-full  hidden sm:grid  sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4' style={{ zIndex: 9999 }}
            ref={filterRef}>
            <div className='border text-left p-2 relative whitespace-nowrap h-20'>
                <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center p-1 cursor-pointer' onClick={() => setActivityModal("Filed Agent")}>
                        <div className='flex gap-3'>
                            <input type='checkbox'
                                checked={isAllSelected('fieldAgents', fieldAgentOptions)}
                                onChange={(e) => handleSelectAll('fieldAgents', fieldAgentOptions, e.target.checked)} />
                            <span className='text-sm text-white'>Field Agent</span>
                        </div>
                        <IoIosArrowUp size={10} color='white' className='justify-end' />
                    </div>
                    <div className='flex  gap-2 p-1 cursor-pointer'>
                        <RxCross2 size={20} color='red' onClick={(e) => handleSelectAll('fieldAgents', fieldAgentOptions)} />
                        <span className='text-sm text-white'>Selected {selectData?.['fieldAgents'].length}/{fieldAgents.length}</span>
                    </div>
                </div>
                {activityModal === "Filed Agent" &&
                    <div className=' h-[222px] overflow-y-auto absolute bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2'>
                        <div className='flex justify-between items-center mb-2'>
                            <h1 className='text-left text-sm'>Filed Agent</h1>
                            <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />

                        </div>


                        {(fieldAgents || [])?.map((assignment) => (
                            <div
                                key={assignment}
                                className='flex items-center gap-2 p-1 cursor-pointer'
                                onClick={() => handleFilterToggle("fieldAgents", assignment?.userId)}
                            >
                                <input
                                    type='checkbox'
                                    checked={isChecked("fieldAgents", assignment?.userId)}
                                    readOnly
                                    className='text-blue-500'
                                />
                                <span className='text-sm'>{assignment?.name?.replace('_', ' ')}</span>
                            </div>
                        ))}

                    </div>}
            </div>

            {/* <div className='border text-left p-2 relative whitespace-nowrap h-20'>
                <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center p-1 cursor-pointer' onClick={() => setActivityModal("visitStatuses")} >
                        <div className='flex gap-3'>
                            <input type='checkbox'
                                checked={isAllSelected('visitStatuses', visitStatusesOptions)}
                                onChange={(e) => handleSelectAll('visitStatuses', visitStatusesOptions, e.target.checked)} />
                            <span className='text-sm text-white'>Visti Status</span>
                        </div>
                        <IoIosArrowUp size={10} color='white' className='justify-end' />
                    </div>
                    <div className='flex  gap-2 p-1 cursor-pointer'>
                        <RxCross2 size={20} color='red' onClick={(e) => handleSelectAll('visitStatuses', visitStatusesOptions)} />
                        <span className='text-sm text-white'>Selected {selectData?.['visitStatuses'].length}/3</span>
                    </div>
                </div>
                {activityModal === "visitStatuses" && <div className=' h-[222px] overflow-y-auto absolute bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2'>
                    <div className='flex justify-between items-center mb-2'>
                        <h1 className='text-left text-sm'>Visti Status</h1>
                        <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />

                    </div>
                    {['Unvisited', 'Completed', 'Unsuccessful'].map((visit) => (
                        <div
                            key={visit}
                            className='flex items-center gap-2 p-1 cursor-pointer'
                            onClick={() => handleFilterToggle("visitStatuses", visit)}
                        >
                            <input
                                type='checkbox'
                                checked={isChecked("visitStatuses", visit)}
                                readOnly
                                className='text-blue-500'
                            />
                            <span className='text-sm'>{visit.replace('_', ' ')}</span>
                        </div>
                    ))}

                </div>}

            </div> */}

            <div className='border text-left p-2 relative whitespace-nowrap h-20'>
                <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center p-1 cursor-pointer' onClick={() => setActivityModal("taskPriority")} >
                        <div className='flex gap-3'>
                            <input type='checkbox'
                                checked={isAllSelected('taskPriority', priorityStatusesOptions)}
                                onChange={(e) => handleSelectAll('taskPriority', priorityStatusesOptions, e.target.checked)} />
                            <span className='text-sm text-white text-nowrap'>Priority Level</span>
                        </div>
                        <IoIosArrowUp size={10} color='white' className='justify-end' />
                    </div>
                    <div className='flex  gap-2 p-1 cursor-pointer'>
                        <RxCross2 size={20} color='red' onClick={(e) => handleSelectAll('taskPriority', priorityStatusesOptions)} />
                        <span className='text-sm text-white'>Selected {selectData?.['taskPriority'].length}/3</span>
                    </div>
                </div>
                {activityModal === "taskPriority" &&
                    <div className=' h-[222px] overflow-y-auto absolute bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2'>
                        <div className='flex justify-between items-center mb-2'>
                            <h1 className='text-left text-sm'>Priority</h1>
                            <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />

                        </div>
                        {priorityStatusesOptions.map((priority) => (
                            <div
                                key={priority}
                                className='flex items-center gap-2 p-1 cursor-pointer'
                                onClick={() => handleFilterToggle("taskPriority", priority)}
                            >
                                <input
                                    type='checkbox'
                                    checked={isChecked("taskPriority", priority)}
                                    readOnly
                                    className='text-blue-500'
                                />
                                <span className='text-sm'>{priority.replace('_', ' ')}</span>
                            </div>
                        ))}
                    </div>}
            </div>

            <div className='border text-left p-2 relative whitespace-nowrap h-20'>
                <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center p-1 cursor-pointer' onClick={() => setActivityModal("taskStatus")}>
                        <div className='flex gap-3'>
                            <input type='checkbox'
                                checked={isAllSelected('taskStatus', taskStatusesOptions)}
                                onChange={(e) => handleSelectAll('taskStatus', taskStatusesOptions, e.target.checked)} />
                            <span className='text-sm text-white text-nowrap'>Task Status</span>
                        </div>
                        <IoIosArrowUp size={10} color='white' className='justify-end' />
                    </div>
                    <div className='flex  gap-2 p-1 cursor-pointer'>
                        <RxCross2 size={20} color='red' onClick={(e) => handleSelectAll('taskStatus', taskStatusesOptions)} />
                        <span className='text-sm text-white'>Selected {selectData?.['taskStatus'].length}/4</span>
                    </div>
                </div>
                {activityModal === "taskStatus" &&
                    <div className=' h-[222px] overflow-y-auto absolute bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2'>
                        <div className='flex justify-between items-center mb-2'>
                            <h1 className='text-left text-sm'>Task Status</h1>
                            <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />

                        </div>
                        {taskStatusesOptions.map((status) => (
                            <div
                                key={status}
                                className='flex items-center gap-2 p-1 cursor-pointer'
                                onClick={() => handleFilterToggle("taskStatus", status)}
                            >
                                <input
                                    type='checkbox'
                                    checked={isChecked("taskStatus", status)}
                                    readOnly
                                    className='text-blue-500'
                                />
                                <span className='text-sm'>{status.replace('_', ' ')}</span>
                            </div>
                        ))}
                    </div>}
            </div>

            {/* <div className='border text-left p-2 relative whitespace-nowrap h-20'>
                <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center p-1 cursor-pointer' onClick={() => setActivityModal("assignmentTypes")}>
                        <div className='flex gap-3'>
                            <input type='checkbox'
                                checked={isAllSelected('assignmentTypes', assignmentOptions)}
                                onChange={(e) => handleSelectAll('assignmentTypes', assignmentOptions, e.target.checked)} />
                            <span className='text-sm text-white text-nowrap'>Assignments</span>
                        </div>
                        <IoIosArrowUp size={10} color='white' className='justify-end' />
                    </div>
                    <div className='flex  gap-2 p-1 cursor-pointer'>
                        <RxCross2 size={20} color='red' onClick={(e) => handleSelectAll('assignmentTypes', assignmentOptions)} />
                        <span className='text-sm text-white'>Applied Filters {selectData?.['assignmentTypes'].length}/2</span>
                    </div>
                </div>
                {activityModal === "assignmentTypes" &&
                    <div className='absolute rounded-md bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2'>
                        <div className='flex justify-between items-center mb-2'>
                            <h1 className='text-left text-sm'>Assignments</h1>
                            <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />

                        </div>

                        {assignmentOptions.map((assignment) => (
                            <div
                                key={assignment}
                                className='flex items-center gap-2 p-1 cursor-pointer'
                                onClick={() => handleFilterToggle("assignmentTypes", assignment)}
                            >
                                <input
                                    type='checkbox'
                                    checked={isChecked("assignmentTypes", assignment)}
                                    readOnly
                                    className='text-blue-500'
                                />
                                <span className='text-sm'>{assignment.replace('_', ' ')}</span>
                            </div>
                        ))}
                    </div>}
            </div> */}

            <div className='border text-center p-2 relative whitespace-nowrap h-20'>
                <div className='flex justify-between p-1 cursor-pointer h-full items-center' onClick={() => setActivityModal("accountNo")}>
                    <span className='text-sm text-white text-nowrap'>Account Number</span>
                    <IoIosArrowUp size={10} color='white' className='justify-end' />
                </div>
                {activityModal === "accountNo" &&
                    <div className='absolute rounded-md bottom-full left-0 w-full bg-black bg-opacity-80 text-white border border-gray-600 p-2 overflow-y-auto h-[200px]'>
                        <div className='flex justify-between mb-2'>
                            <h1 className='text-left text-sm'>Account No</h1>
                            <IoIosArrowDown size={10} color='white' className='justify-end' onClick={() => setActivityModal("")} />
                        </div>

                        <input
                            type="text"
                            placeholder="Search account no..."
                            value={searchAccount}
                            onChange={handleSearchAccount}
                            className="w-full p-2 border border-gray-300 text-black rounded-md text-xs mb-2"
                        />
                        {(filteredAccounts || [])?.map((task, inx) => (
                            <div
                                key={inx}
                                className='flex items-center gap-2 p-1 cursor-pointer'
                                onClick={() => handleFilterToggle("accountNo", task?.accountNo)}
                            >
                                <input
                                    type='radio'
                                    checked={isChecked("accountNo", task?.accountNo)}
                                    readOnly
                                    className='text-blue-500'
                                />
                                <span className='text-sm'>{task?.accountNo.replace('_', ' ')}</span>
                            </div>
                        ))}
                    </div>}
            </div>
        </div>
    );
};

export default BottomFilter;
